import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/Users/wilmer/projects/wilmercantillo.com/src/components/md/index.tsx";
import { graphql } from 'gatsby';
export const ProjectQuery = graphql`
  {
    site {
      siteMetadata {
        description
        title
      }
    }
    banner: file(
      relativePath: {
        eq: "project/modbus-lora-communication/images/banner.jpeg"
      }
    ) {
      childImageSharp {
        gatsbyImageData(layout: FULL_WIDTH, placeholder: BLURRED)
      }
    }
  }
`;
export const _frontmatter = {};
const layoutProps = {
  ProjectQuery,
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">




    <h2>{`Objetivo`}</h2>
    <p>{`Extraer mediciones de un dispositivo shark 100 con la plataforma/placa Arduino a
través del protocolo MODBUS para luego transmitir los datos por medio del
protocolo LoRa con un modulo de RF.`}</p>
    <h2>{`Sobre el Proyecto`}</h2>
    <p>{`Este fue mi proyecto final para el curso de comunicaciones en el cual aprendí
sobre protocolos de comunicación, aquí se tuvo en cuenta muchas de las cosas
aprendidas en cursos anteriores, como medios de transmisión, análisis de señales
y sistemas, teoría electromagnética, circuitos, entre otros.`}</p>
    <p>{`Al momento de yo empezar a trabajar en este proyecto, liderado por el profesor
de la asignatura, ya se encontraba en proceso y consistía en la comunicación de
los registros de un analizador shark 100 con una raspberry pi por medio de
MODBUS, sin embargo, el uso de la raspberri pi era algo excesivo debido a la
baja demanda de la tarea, por lo que el objetivo de nuestro proyecto era
reemplazarla por un Arduino y empezar a realizar pruebas de transmisión por
lora. A continuación, una imagen del analizador de señales eléctricas Shark 100
usado en el laboratorio de la Universidad del norte.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "431px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/7ab7eb2b9e4e7cbae2a16e9a6517fcdf/9cb4e/shark100.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "82.66666666666667%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAARCAYAAADdRIy+AAAACXBIWXMAAAsTAAALEwEAmpwYAAAFCElEQVQ4yy1Ua0zTVxQ///LwMUsLhVIK5dHyKohYoJUWSgu0Uh6ltOVRqFQooFQqWEEUUBoEFRAUJnNi0C3TidHMmChmYeLcFzXOuUxm3Pywb/uw7Itbspjxh3t2a3aSm5Nz77m/8/vde88F/+QF8Pb7GU/fCUgrMG/p7Btu8/QOf9wzMHrLN+hf6j42fK+te+C6s7P3jMXV5cjUWVMQkcmvbgUIiWGAGo0DDlaerwKcnr0MEJUaiDmf3bi9fPPuEt65/wA/mZ/HkfGLODm7gNcXr+HiV3fw4tUv8NS5ubXGA8d+2j84aXX2+MHp6Q9Zfvkrs/ziDVy7twIwMj4dNDw2CSMT51vm5q/g1yuP/vVPzK9Zuh+zzWP/sPX+d+yZhVV25fF37LPvn62/evWSHJm4hKV1He/Npt1RDW09HxjO31pizl7+EmDg2ADj8XSBt3dwZWxyBlv2dbGbuUmYkmIj6TluotMPEnnhOA6dWSBvfnlFnj1/SkamL7LGagdm5Gjv+WevtlPAiBsPHsP0lUUGHG4v1DS1J7Z2+v5yew4jN1KyIQzlkUIIRQ2EoJt6Mz2m1gIDfvv0Cfnm4TLu9w1iboGRRIqTMVdbjp6BUyui2LjgElMFgK7MCrurHTZbUxvKd6jZrWHRJC0xE9MiElHJjcOmrWI0csLRlJKNY1PncXrmAqmsayVZeUUYIUxkpekKLDTWvGs9NCR2+44DZKv0YDQ3HC80WFAQncTyImIxJjYVY+LSURgvx/iEDBRK5BgRI0NbfTPaG1swO9+ICnUJiUnI2NCZrFhS43y79MOPQdeWHwFk5elAU1y1UEABAxUDDGUMD1XAQw3DRwdll7tFiHEiKeZpSlCh0qM8R4v5+iqscOwlNU4XqbO40Np8YKba6QWgIJCt1N2WyfOQy49lt/FEKOOKMSNEgHYmHDsocN3maNSk7cTkrF0oTVNgZq4WtWX1xD97GuemTq6da3Bhbadv0eLxAYgTMwKybwaqCkQyNowvJpExKVRiMgqpTxDKUBghQYFAgtH0KATRUlQVmbCiYR8Zv3qJTI+OkjmPD21HRvYY+08CSDOVkKct+zSvqAJlmflscCifKDh8TA0VYDGVmr8thgLGY1hkAvIF8RglTkFDdSPWug+hsb5l3eLqxpbuk/f93j441dHFQEZuEWhN9qH8UgsqDfa1KK4IkyGMJDLhpB3CsZZKtvAlmKnUYer2XUQi24G1rd1Epask6fLsNZ3JhhbXQXtNex+UN3UGgcZoBW15nbHAaEOVec+aM0uz/jBZRmYk8TjEFxIbZbwzWoZF5bVEXWImcoUW69t9JEtZjCKxlM7XYXOPf5e7dwwszV0cWH6xCk9Wf2b05qYlXaUDVQYbTpWWr/8pi2P/NhRu3EyXE62+iiiLq8kO+lyURRUbtr0HKVvV+4Qk+e8O98Hjv9HWC7Sf3U0vhbJjdJUNcHR0KkRbZutS6qtey3VVqKYdUKk3Y47Bjgara8Pb518vNTeydB1tLT1/SFPSSsN53KTDE9ehjvZzmd0FtR39AAVldijYbWV8J05/kJ8QG8tNTc3cn7pTfVeuNrxVaAzrWfTtlVY1YFlNE9r2etHe3ttJf6eg4E1bwyNFks3wvyl15QDqUguYnQegvu0Q0M3BgcTPH7z+IIEGUZGCKIUgStS4jSfwZOfm13oPH91OczZxOEFhwcEhHwXyGQ4HOHQE7D+1dh4aSxKwSgAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Shark 100",
            "title": "Shark 100",
            "src": "/static/7ab7eb2b9e4e7cbae2a16e9a6517fcdf/9cb4e/shark100.png",
            "srcSet": ["/static/7ab7eb2b9e4e7cbae2a16e9a6517fcdf/5a46d/shark100.png 300w", "/static/7ab7eb2b9e4e7cbae2a16e9a6517fcdf/9cb4e/shark100.png 431w"],
            "sizes": "(max-width: 431px) 100vw, 431px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
  `}</a>{`
    `}</span></p>
    <h2>{`Construcción del proyecto`}</h2>
    <p>{`Para realizar la obtención los datos se uso un arduino uno para probar la
posibilidad y efectividad de la idea.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1200px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/0b2e12313863a1d039baaaf0e97515ba/96191/arduino.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "87.99999999999999%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAASCAYAAABb0P4QAAAACXBIWXMAAAsTAAALEwEAmpwYAAAE7klEQVQ4y41Ua0yTVxh+S10Wd9F5mSiXoKgFpIgttRRov5aWr1+v0K8Xyk2EtpZLJzdFpWhkVG4i0ioUSlEqgg4dJDpcXOa2ZMnmlmXRabIs0cSQLbv82LL9WDSUfu+qWzQsWbLnz3lzcs5z3vOc5zkA/4JVkwNqrQbMFiMYzTSsXrOWpSLFQOx4A6QUxdKeuwe2KhOrtooG514aHJVG+E9UWI2g1OmgyGwCS6k1Jrz4EyQlJYBGJdPlZ3PW7kp6GdIJM/v65T5ARFCpSJZUQYK+0ACUSrWczELrQKrWgYY2Al1czB4KBp/NC0WiPi43BSWK/KyyyjIAnguuzfhW4e/fsRSKArCfHIR0vgjSUzazlhFyMrMgL3pagVrNPuh2w+37918RCAXvxm7ciJwcFUO5un/WNnTNpOucvYoC8c1ig0whyJYkEFcm4c7tbyFlW9ILMnnV27CDxwdSo40pMtHQ1T+QKMjOvrvuzQ0Yl0WFC+p7GUPbKFLNQ0iVNKGQUGO2jPxBSSlRW6gp3WuvgzRO8k5EE4B4nw/cXT0gluSxCvUqoA3a1Czh7u83JSRgYm7RosjRw9T0T2Nu03hky56RsNR6MKw3WiOkRoOKAikSFsePQrl6Nk/AGUiOXwswPzcB3uGzQBWaXtrO5cGadbGWDXEJuIuyPiH2daLLe5U5cfFDRrR/nEmrDWGq9W2mQEkxSqU8kiYUR4jy1khWjgTLqyw1BpoEOH8+CCdOD7E7fONQ3z/yutp2+GNJRTuKa32RktZBxtV9npE3j+OWyiAKHIOo0eqQVJIMIRUhj3YtZRBFqKSk9x4grvzs4QKA1z8a0zEYBLIxFDsSGPlmKuTHnjOhJbnJidnmFiav3o+apiEsbb+Im9KVmJi4GXNyhQyXKmWE9FsRQiHDuvY2bXVTA1jsdjbYDp+BKvcIxz8aeDh7aQznpscWL4fOoGGvk+EXH2R4zgHk2U6hxHoI1+12IXu9iOEraDzhvxzmiQjUW+nZf942Zv7r2wCTE5MQDJy7dHUqiLNTgcfzVwKRBlfZEpcsY7iWoyh2eBheZRdDGUpQVOpm+CY345u+xQwM9GO+WvnE2dGduudQO9hammP6z0W9S5EmMOtMeRPTN/HS1CTW2Axod5jRUl6xZLC3LKWWdKKirh959WOMQFXBGGuP4pA/GN5XW42kvaV7m7QQBCqavT4hAZo7jsGzCD2OILz/5S91p7zDi5wtsQsyU9UHrsYmVJptyCWKwuUV5RGVxYZqvYHRm01LG7fy0FTT+Ojur3++duPRH3DYF3yREseBAPj281mDw1H7nB5Mt5skaW1nvSB2DpsVDYH7RzpOokKpQ0Imj/rPyFQ7beGi0j1IlVVV5BYWA1VWzdY3euC499TfhEc80+AOIQyNTrCH/WNQTGZCT3CARdT4n3a/YvbThfqMTOGTtIxczBFLFzs8R3D2xvyt36I3u/A5w7rzxVUQFrtexO76Jw+e1729fSydLJPFWpkM+v1e9lM5Ovv9EBu7SR4Xv/2rtJ18NNlt6OnpFvRFO2rzdMRMzoxBaObC8p9Gzt8OOkkqUKIUaPKEoHf0GrT6PoLuuQWoP3BsxZpVq5+tyxDlKyz17kLYWgmQbInqthWO93TC/0LrwHvP6/i4ePbTMU0gBmOtG16VNETJUqOSzMGVd8aX7fsLg4YEiCUx60AAAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Arduino Uno",
            "title": "Arduino Uno",
            "src": "/static/0b2e12313863a1d039baaaf0e97515ba/c1b63/arduino.png",
            "srcSet": ["/static/0b2e12313863a1d039baaaf0e97515ba/5a46d/arduino.png 300w", "/static/0b2e12313863a1d039baaaf0e97515ba/0a47e/arduino.png 600w", "/static/0b2e12313863a1d039baaaf0e97515ba/c1b63/arduino.png 1200w", "/static/0b2e12313863a1d039baaaf0e97515ba/d61c2/arduino.png 1800w", "/static/0b2e12313863a1d039baaaf0e97515ba/96191/arduino.png 2176w"],
            "sizes": "(max-width: 1200px) 100vw, 1200px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
  `}</a>{`
    `}</span></p>
    <p>{`Este fue un proceso de prueba y error, inicialmente realizamos una búsqueda y
selección de librerías de Arduino que nos pudrieran servir para implementar el
protocolo MODBUS. Finalmente decidimos usar la librería `}<em parentName="p">{`ModbusRtu`}</em>{`, el script
para la comunicación lo pueden encontrar en el repositorio de GitHub.`}</p>
    <p>{`Además, contamos con un modulo LoRaWAN de la empresa Seeed Studio, el cual
cuenta con varios radios transmisores y un Gateway.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "600px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/e63041d4f51aacdcdf5f15a32c73758f/e88ff/gateway.webp",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "72.66666666666667%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/webp;base64,UklGRqgBAABXRUJQVlA4WAoAAAAQAAAAEwAADgAAQUxQSN4AAAABgGrb1rFtv/htNttIdrNt27YRbWdbyf8l/ONPNqL94sM1RMQEQKSWpjQECYikUME8Xx0frcyHghRBY4gRPgBaBIUc5uvv9/eDaRZDEoHM79/PzydTJwZgfPnHCFYLI4FkXTkf97iOqf1Td5AACKDvxfuJaTydt7Yv1BAgYOyVGWTSkOH6lte0UTbmBsH9zoLUsoxwM02ETlcNqIIAdHWc+6LCE5Md7cpOtm9TQQK0ITRLW8+YCyVs7qhHP0IoCUAuMQ76Z0BXN0gABEBSEJxanBkmISZBUQRIbzeAAABWUDggpAAAAFAEAJ0BKhQADwA+0VSjS6gkoyGwCAEAGglsALDtiua18vF/qzgnBLMVCgAA/Fp45WCQLGq4sz1cgLIwnRr1tSD2oxvcyHTIw5YccpWI417EjGEkkrZ8P0PPXFP/fO7GXgkEHhjtIjtn6uK3cBdbPjnpx0f7qYupOyPj13fK/9X284syHATPndplzPevdNxBRaZJrfCGbyM6N2WJw/df/uey1dAA')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Seeduino Lorawan",
            "title": "Seeduino Lorawan",
            "src": "/static/e63041d4f51aacdcdf5f15a32c73758f/e88ff/gateway.webp",
            "srcSet": ["/static/e63041d4f51aacdcdf5f15a32c73758f/c85cb/gateway.webp 300w", "/static/e63041d4f51aacdcdf5f15a32c73758f/e88ff/gateway.webp 600w"],
            "sizes": "(max-width: 600px) 100vw, 600px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
  `}</a>{`
    `}</span></p>
    <p>{`Dicho modulo cuenta con buena documentación por lo que nos resulto sencillo la
comunicación entre nodo transmisor y Gateway.`}</p>
    <h2>{`Conclusión`}</h2>
    <p>{`De esta manera logramos una comunicación unidireccional para obtener los datos
de la red eléctrica de la siguiente manera: El analizador media los datos, los
cuales quedaban guardados en sus registros, usamos Arduino para sacar dichos
datos de los registros y enviarlos al dispositivo seeeduino el cual transmitía
la información al Gateway donde este finalmente podía guardar dichos datos en
una base de datos local o la nube. Muy parecido a lo siguiente:`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1200px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/32e50f02cd141da32b041c91345e4a62/c1b63/data_flow.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "35.333333333333336%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAHCAYAAAAIy204AAAACXBIWXMAAHTMAAB0zAGg32SdAAABxUlEQVQozy1Sy04UURCdb/M3TNxpdMfSlQuJbliwNi6MQSQwBBwkGIMgQ2aYAXqafky/bz/u9GNapmfCB9h1rG5ZVM6tm1tVp865Ha+M/05Tn25cjdwipLBKOWYtisUjcsR8FzFGy4ziJSPn4vGNX8Zt8LnuOJmoVcfEp7NLGLMAY1PF6dUQ17aGeJXDygLYqQ8lk7BKCYfzu1xCLxK4hYCROPg1ukBfGWA686jjFVFtCAebXw9oEtikGBoNVZ1uHIPZpKQJiyaORh91SUdeTBfKgLbMiLYtSXagU3A/I9U3aaCNYUqXOuEyraNVBiVwudiGJkOeHCK4l/D/JOj9PsHuSRdnjoVpmSJaSKjzDJe81c7RLq4sBapr0Pr7dxhNJ9QRC1mLVYlM36fqwxPk5xswU4GReQvF07G28RpP3zxH72cPduKhfzuEyxL0zo/x7O1LvFpfQ8Ow+20HZmIzQxZSrOaQ6h4t9l8g72/CycO2meobODz9js/dLxgbCrwihpdHYGNwF1rYPtjC8Y896M41RbnNmmfMsEprbgrxUFHwUKGJaJm3RRYzadZnB1vx3fn/Zuw87EzwYMGGeQjKqPkNaBz/B3dF42ioCtUPAAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Data Flow",
            "title": "Data Flow",
            "src": "/static/32e50f02cd141da32b041c91345e4a62/c1b63/data_flow.png",
            "srcSet": ["/static/32e50f02cd141da32b041c91345e4a62/5a46d/data_flow.png 300w", "/static/32e50f02cd141da32b041c91345e4a62/0a47e/data_flow.png 600w", "/static/32e50f02cd141da32b041c91345e4a62/c1b63/data_flow.png 1200w"],
            "sizes": "(max-width: 1200px) 100vw, 1200px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
  `}</a>{`
    `}</span></p>
    <p>{`Un patrón de flujo de datos muy recurrente en aplicaciones IOT.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      